import { render, staticRenderFns } from "./inputRadio.pug?vue&type=template&id=757e65de&lang=pug&"
import script from "./inputRadio.js?vue&type=script&lang=js&"
export * from "./inputRadio.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('757e65de')) {
      api.createRecord('757e65de', component.options)
    } else {
      api.reload('757e65de', component.options)
    }
    module.hot.accept("./inputRadio.pug?vue&type=template&id=757e65de&lang=pug&", function () {
      api.rerender('757e65de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/radio/index.vue"
export default component.exports